import { useCallback } from "react";

import { getDolarFallback } from "../../../utils/exchangeRateService";

export const useVPAggregation = ({
  cierresPorAno,
  facturacionPorAno,
  cierresPorAnoOtro,
  facturacionPorAnoOtro,
  showInDollars,
  modoCombinado,
  dolarMensual,
  dolarMensualOtroPais,
  tipoCambioActual,
  tipoCambioOtroPais,
  pais,
}) => {
  const getDesglose = useCallback(
    (year, startMonth, endMonth, tipo) => {
      // Lookup directo por año: los mapas se rellenan en el precómputo con el año
      // seleccionado + comparativos (AA / AAA). Sin literales.
      const data = tipo === "cierres" ? cierresPorAno?.[year] : facturacionPorAno?.[year];

      // Datos del otro país (para modo combinado)
      const dataOtro = tipo === "cierres" ? cierresPorAnoOtro?.[year] : facturacionPorAnoOtro?.[year];

      if (!data) return { publicidad: 0, hardware: 0, carteleria: 0, btl: 0, total: 0 };

      // Sumar con conversión a USD por mes
      const sumarConDolar = (arr) => {
        if (!arr) return 0;
        let suma = 0;
        for (let i = startMonth - 1; i < endMonth; i++) {
          const valorMes = arr[i] || 0;
          // Fallback en cascada: dólar del mes → tipo de cambio actual del hook →
          // último valor del service (por si hook no actualizó aún) → 1 (último recurso).
          const rate = dolarMensual[i] || tipoCambioActual || getDolarFallback(pais) || 1;
          suma += showInDollars || modoCombinado ? valorMes / rate : valorMes;
        }
        return suma;
      };

      // Sumar sin conversión (para moneda local)
      const sumar = (arr) => (arr ? arr.slice(startMonth - 1, endMonth).reduce((s, v) => s + (v || 0), 0) : 0);

      if (modoCombinado && dataOtro) {
        // Modo combinado: sumar ambos países en USD
        const pubLocal = sumarConDolar(data.publicidad);
        const hwLocal = sumarConDolar(data.hardware);
        const cartLocal = sumarConDolar(data.carteleria);
        const btlLocal = sumarConDolar(data.btl);

        // Otro país (usar su tipo de cambio MENSUAL)
        const otroPais = pais === "Chile" ? "Perú" : "Chile";
        const sumarOtroPais = (arr) => {
          if (!arr) return 0;
          let suma = 0;
          for (let i = startMonth - 1; i < endMonth; i++) {
            const valorMes = arr[i] || 0;
            const rateOtro = dolarMensualOtroPais[i] || tipoCambioOtroPais || getDolarFallback(otroPais) || 1;
            suma += valorMes / rateOtro;
          }
          return suma;
        };

        const pubOtro = sumarOtroPais(dataOtro.publicidad);
        const hwOtro = sumarOtroPais(dataOtro.hardware);
        const cartOtro = sumarOtroPais(dataOtro.carteleria);
        const btlOtro = sumarOtroPais(dataOtro.btl);

        const pub = pubLocal + pubOtro;
        const hw = hwLocal + hwOtro;
        const cart = cartLocal + cartOtro;
        const btl = btlLocal + btlOtro;
        return { publicidad: pub, hardware: hw, carteleria: cart, btl, total: pub + hw + cart + btl };
      }

      // Modo normal
      if (showInDollars) {
        const pub = sumarConDolar(data.publicidad);
        const hw = sumarConDolar(data.hardware);
        const cart = sumarConDolar(data.carteleria);
        const btl = sumarConDolar(data.btl);
        return { publicidad: pub, hardware: hw, carteleria: cart, btl, total: pub + hw + cart + btl };
      }

      // Moneda local
      const pub = sumar(data.publicidad);
      const hw = sumar(data.hardware);
      const cart = sumar(data.carteleria);
      const btl = sumar(data.btl);
      return { publicidad: pub, hardware: hw, carteleria: cart, btl, total: pub + hw + cart + btl };
    },
    [
      cierresPorAno,
      facturacionPorAno,
      cierresPorAnoOtro,
      facturacionPorAnoOtro,
      showInDollars,
      modoCombinado,
      dolarMensual,
      dolarMensualOtroPais,
      tipoCambioActual,
      tipoCambioOtroPais,
      pais,
    ]
  );

  return { getDesglose };
};
